var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHarmony(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "url(#paint0_linear_1275_22504)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.8315 33.9999C29.0668 33.9999 27.6313 32.5644 27.6313 30.7997V24.908C30.5451 24.6827 32.6531 24.0655 34.0317 23.0577V30.7997C34.0317 32.5644 32.5961 33.9999 30.8315 33.9999ZM27.6313 17.2001C27.6313 15.4355 29.0668 13.9999 30.8315 13.9999C32.5961 13.9999 34.0317 15.4355 34.0317 17.2001V19.1334C34.0004 19.8133 33.8529 20.5118 33.2543 21.1132C32.5537 21.8161 31.0025 22.6093 27.6313 22.8942V17.2001ZM20.4107 30.7997C20.4107 32.5644 18.9751 33.9999 17.2104 33.9999C15.4457 33.9999 14.0102 32.5644 14.0102 30.7997V29.0056C14.0423 28.3521 14.1993 27.6394 14.8462 26.9882C15.5739 26.2545 17.125 25.4302 20.4107 25.1219V30.7997ZM17.2104 13.9999C18.9751 13.9999 20.4107 15.4355 20.4107 17.2001V23.1097C17.5187 23.3579 15.4091 24.0165 14.0102 25.0883V17.2001C14.0102 15.4355 15.4457 13.9999 17.2104 13.9999ZM36.0365 18.3398L36.0317 17.9999V17.2001C36.0317 14.333 33.6987 12 30.8315 12C27.9643 12 25.6313 14.333 25.6313 17.2001V22.9903C25.1257 23.0005 22.939 22.9977 22.4106 23.0098V17.2001C22.4106 14.333 20.0776 12 17.2104 12C14.3432 12 12.0102 14.333 12.0102 17.2001V28.9063C11.9939 29.2239 12.0007 29.5077 12.0063 29.7412L12.0102 30V30.7997C12.0102 33.6669 14.3432 36 17.2104 36C20.0776 36 22.4106 33.6669 22.4106 30.7997V25.0136C22.9216 25.0011 25.1092 25.0049 25.6313 24.9957V30.7997C25.6313 33.6669 27.9643 36 30.8315 36C33.6987 36 36.0317 33.6669 36.0317 30.7997V19.2417C36.0483 18.9073 36.0423 18.6011 36.0365 18.3398Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1275_22504",
    x1: 48,
    y1: -0.00000286102,
    x2: 0.00000286102,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CFBBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05B3E6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHarmony);
export default __webpack_public_path__ + "static/media/harmony.e8b8caeeccc583e78f37df658fa60751.svg";
export { ForwardRef as ReactComponent };